import { useState } from "react";
import ModalMessage from "./ModalMessage";
import React from "react";

export function useModalMessage() {
  const [state, setState] = useState<{
    show: boolean;
    message: React.ReactNode;
    typeMessage: "success" | "danger" | "warning" | "info";
    title: React.ReactNode;
  }>({
    show: false,
    message: "",
    typeMessage: "warning",
    title : ""
  });

  const alertModal = (
    message: React.ReactNode,
    typeMessage:"success" | "danger" | "warning" | "info" = "warning",
    title: React.ReactNode = "",
  ) => {
    setState({
      show: true,
      message,
      typeMessage,
      title: title,
    });
  };

  const handleClose = () =>
    setState((prev) => ({ ...prev, show: false }));

  const ModalMessageEl = (
    <ModalMessage
      show={state.show}
      title={state.title}
      message={state.message}
      typeMessage={state.typeMessage}
      onClose={handleClose}
    />
  );

  return { alertModal, ModalMessageEl };
}
